
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m6.111 2-.088.011-.048.011-2.987.072c-.501.013-.903.396-.888.864.014.417.353.75.782.807l.148.009.86-.023-.13.12C2.644 4.941 2 6.363 2 7.854c0 2.213 1.361 4.207 3.546 5.202a.974.974 0 0 0 .405.087.927.927 0 0 0 .814-.456c.235-.42.049-.931-.408-1.138-1.562-.711-2.528-2.126-2.528-3.695l.008-.252c.07-1.004.553-1.951 1.342-2.662l.107-.092.028.844c.013.417.352.75.783.807l.148.009c.511-.014.913-.398.897-.866l-.09-2.816c-.015-.478-.44-.839-.941-.826zm3.124 1.313c-.235.42-.049.93.407 1.138 1.563.711 2.529 2.126 2.529 3.696l-.009.252c-.07 1.004-.553 1.95-1.341 2.662l-.108.09-.027-.843c-.015-.47-.446-.838-.948-.814-.493.012-.895.396-.88.864l.093 2.84c.013.405.351.736.781.793L9.88 14l.097-.01.049-.012 2.987-.072c.501-.013.902-.396.887-.864l-.012-.115c-.075-.413-.477-.722-.937-.7l-.842.02.132-.118C13.355 11.059 14 9.638 14 8.146c0-2.213-1.361-4.207-3.546-5.202-.447-.202-.99-.04-1.22.37z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"m6.111 2-.088.011-.048.011-2.987.072c-.501.013-.903.396-.888.864.014.417.353.75.782.807l.148.009.86-.023-.13.12C2.644 4.941 2 6.363 2 7.854c0 2.213 1.361 4.207 3.546 5.202a.974.974 0 0 0 .405.087.927.927 0 0 0 .814-.456c.235-.42.049-.931-.408-1.138-1.562-.711-2.528-2.126-2.528-3.695l.008-.252c.07-1.004.553-1.951 1.342-2.662l.107-.092.028.844c.013.417.352.75.783.807l.148.009c.511-.014.913-.398.897-.866l-.09-2.816c-.015-.478-.44-.839-.941-.826zM9.235 3.313c-.235.42-.049.93.407 1.138 1.563.711 2.529 2.126 2.529 3.696l-.009.252c-.07 1.004-.553 1.95-1.341 2.662l-.108.09-.027-.843c-.015-.47-.446-.838-.948-.814-.493.012-.895.396-.88.864l.093 2.84c.013.405.351.736.781.793L9.88 14l.097-.01.049-.012 2.987-.072c.501-.013.902-.396.887-.864l-.012-.115c-.075-.413-.477-.722-.937-.7l-.842.02.132-.118C13.355 11.059 14 9.638 14 8.146c0-2.213-1.361-4.207-3.546-5.202-.447-.202-.99-.04-1.22.37z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/spinner.150c86783ab56450c7d30eed84744770.svg"),
        {
          React: SvgSpinner,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      